import { render } from "./RequestElement.vue?vue&type=template&id=9aadaeda&scoped=true"
import script from "./RequestElement.vue?vue&type=script&lang=js"
export * from "./RequestElement.vue?vue&type=script&lang=js"

import "./RequestElement.vue?vue&type=style&index=0&id=9aadaeda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aadaeda"]])

export default __exports__